import { IconPropsType } from '..';

export const FaFlag = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_12444_86138"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <circle
          cx="10"
          cy="10"
          r="10"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_12444_86138)">
        <path
          d="M38 -6H-18V26H38V-6Z"
          fill="white"
        />
        <path
          d="M38 15.4875H-18V26H38V15.4875Z"
          fill="#DA0000"
        />
        <path
          d="M27.35 15.9375H24.2875V16.1438H27.35V15.9375ZM26.8937 16.9875H26.6812V17.1938H26.8937V16.9875ZM24.275 16.9875V17.1938H24.8875V16.9813L24.275 16.9875ZM23.95 15.9375H23.7375V17.1875H23.95V15.9375Z"
          fill="white"
        />
        <path
          d="M22.725 16.9813V17.1938H23.8875V16.9813H22.725ZM24.8875 16.4875H24.6875V17.1938H24.8937L24.8875 16.4875Z"
          fill="white"
        />
        <path
          d="M22.9 15.9375H22.6875V17.1875H22.9V15.9375ZM23.425 15.9375H23.2187V17.1875H23.425V15.9375ZM26.225 16.4375V16.65H27.35V16.4375H26.225ZM23.7687 16.4375V16.65H24.8937V16.4375H23.7687Z"
          fill="white"
        />
        <path
          d="M24.8875 16.4938H24.6875V17.1875H24.8937L24.8875 16.4938Z"
          fill="white"
        />
        <path
          d="M24.8875 16.4938H24.6875V17.1875H24.8937L24.8875 16.4938Z"
          fill="white"
        />
        <path
          d="M24.8875 16.4938H24.6875V17.1875H24.8937L24.8875 16.4938ZM27.3437 16.4938H27.1375V17.1875H27.3437V16.4938ZM25.5437 16.4938H25.3312V17.1875H25.5437V16.4938ZM26.4375 16.4938H26.225V17.1875H26.4375V16.4938Z"
          fill="white"
        />
        <path
          d="M25.4 16.9813V17.1938H26.3437V16.9813H25.4ZM25.3375 16.4375V16.65H25.9375V16.4375H25.3375Z"
          fill="white"
        />
        <path
          d="M32.3875 15.9375H29.325V16.1438H32.3875V15.9375ZM31.9313 16.9875H31.7187V17.1938H31.9375L31.9313 16.9875ZM29.3125 16.9875V17.1938H29.925V16.9813L29.3125 16.9875ZM28.9875 15.9375H28.775V17.1875H28.9875V15.9375Z"
          fill="white"
        />
        <path
          d="M27.7625 16.9813V17.1938H28.925V16.9813H27.7625ZM29.925 16.4875H29.7187V17.1938L29.925 17.1938V16.4875Z"
          fill="white"
        />
        <path
          d="M27.9375 15.9375H27.725V17.1875H27.9375V15.9375ZM28.4625 15.9375H28.2562V17.1875H28.4625V15.9375ZM31.2625 16.4375V16.65H32.3875V16.4375H31.2625ZM28.8062 16.4375V16.65H29.9313V16.4375H28.8062Z"
          fill="white"
        />
        <path
          d="M29.925 16.4938H29.7187V17.1875H29.925V16.4938Z"
          fill="white"
        />
        <path
          d="M29.925 16.4938H29.7187V17.1875H29.925V16.4938Z"
          fill="white"
        />
        <path
          d="M29.925 16.4938H29.7187V17.1875H29.925V16.4938ZM32.3812 16.4938H32.175V17.1875H32.3812V16.4938ZM30.5812 16.4938H30.375V17.1875H30.5812V16.4938ZM31.475 16.4938H31.2625V17.1875H31.475V16.4938Z"
          fill="white"
        />
        <path
          d="M30.4375 16.9813V17.1938H31.375V16.9813H30.4375ZM30.375 16.4375V16.65H30.975V16.4375H30.375Z"
          fill="white"
        />
        <path
          d="M22.3562 15.9375H19.2937V16.1438H22.3562V15.9375ZM21.9 16.9875H21.6875V17.1938H21.9V16.9875ZM19.2812 16.9875V17.1938H19.8937V16.9813L19.2812 16.9875ZM18.95 15.9375H18.7375V17.1875H18.95V15.9375Z"
          fill="white"
        />
        <path
          d="M17.7312 16.9813V17.1938H18.8937V16.9813H17.7312ZM19.8937 16.4875H19.6812V17.1938L19.8937 17.1938V16.4875Z"
          fill="white"
        />
        <path
          d="M17.9062 15.9375H17.6937V17.1875H17.9062V15.9375ZM18.4312 15.9375H18.2187V17.1875H18.4375L18.4312 15.9375ZM21.2312 16.4375V16.65H22.3562V16.4375H21.2312ZM18.775 16.4375V16.65H19.9V16.4375H18.775Z"
          fill="white"
        />
        <path
          d="M19.8937 16.4938H19.6812V17.1875H19.8937V16.4938Z"
          fill="white"
        />
        <path
          d="M19.8937 16.4938H19.6812V17.1875H19.8937V16.4938Z"
          fill="white"
        />
        <path
          d="M19.8937 16.4938H19.6812V17.1875H19.8937V16.4938ZM22.35 16.4938H22.1375V17.1875H22.35V16.4938ZM20.55 16.4938H20.3375V17.1875H20.55V16.4938ZM21.4437 16.4938H21.2312V17.1875H21.4437V16.4938Z"
          fill="white"
        />
        <path
          d="M20.4 16.9813V17.1938H21.35V16.9813H20.4ZM20.3375 16.4375V16.65H20.9375V16.4375H20.3375Z"
          fill="white"
        />
        <path
          d="M-12.9188 15.9375H-15.9813V16.1438H-12.9188V15.9375ZM-13.375 16.9875H-13.5875V17.1938H-13.375V16.9875ZM-15.9938 16.9875V17.1938H-15.375V16.9813L-15.9938 16.9875ZM-16.325 15.9375H-16.5313V17.1875H-16.3187L-16.325 15.9375Z"
          fill="white"
        />
        <path
          d="M-17.5438 16.9813V17.1938H-16.375V16.9813H-17.5438ZM-15.3813 16.4875H-15.5938V17.1938L-15.375 17.1938L-15.3813 16.4875Z"
          fill="white"
        />
        <path
          d="M-17.375 15.9375H-17.5813V17.1875H-17.3688L-17.375 15.9375ZM-16.8438 15.9375H-17.0563V17.1875H-16.8438V15.9375ZM-14.0438 16.4375V16.65H-12.9188V16.4375H-14.0438ZM-16.5 16.4375V16.65H-15.375V16.4375H-16.5Z"
          fill="white"
        />
        <path
          d="M-15.375 16.4938H-15.5938V17.1875H-15.375V16.4938Z"
          fill="white"
        />
        <path
          d="M-15.375 16.4938H-15.5938V17.1875H-15.375V16.4938Z"
          fill="white"
        />
        <path
          d="M-15.375 16.4938H-15.5938V17.1875H-15.375V16.4938ZM-12.925 16.4938H-13.1375V17.1875H-12.925V16.4938ZM-14.725 16.4938H-14.9375V17.1875H-14.725V16.4938ZM-13.8313 16.4938H-14.0438V17.1875H-13.8313V16.4938Z"
          fill="white"
        />
        <path
          d="M-14.875 16.9813V17.1938H-13.925V16.9813H-14.875ZM-14.9375 16.4375V16.65H-14.3375V16.4375H-14.9375Z"
          fill="white"
        />
        <path
          d="M17.3312 15.9375H14.2625V16.1438H17.325L17.3312 15.9375ZM16.8687 16.9875H16.6625V17.1938H16.8687V16.9875ZM14.2562 16.9875V17.1938H14.8687V16.9813L14.2562 16.9875ZM13.925 15.9375H13.7125V17.1875H13.925V15.9375Z"
          fill="white"
        />
        <path
          d="M12.7 16.9813V17.1938H13.8625V16.9813H12.7ZM14.8687 16.4875H14.6562V17.1938L14.8687 17.1938V16.4875Z"
          fill="white"
        />
        <path
          d="M12.875 15.9375H12.6625V17.1875H12.875V15.9375ZM13.4062 15.9375H13.1937V17.1875H13.4062V15.9375ZM16.2062 16.4375V16.65H17.325V16.4375H16.2062ZM13.75 16.4375V16.65H14.8687V16.4375H13.75Z"
          fill="white"
        />
        <path
          d="M14.8687 16.4938H14.6562V17.1875H14.8687V16.4938Z"
          fill="white"
        />
        <path
          d="M14.8687 16.4938H14.6562V17.1875H14.8687V16.4938Z"
          fill="white"
        />
        <path
          d="M14.8687 16.4938H14.6562V17.1875H14.8687V16.4938ZM17.325 16.4938H17.1125V17.1875H17.325V16.4938ZM15.525 16.4938H15.3125V17.1875H15.525V16.4938ZM16.4125 16.4938H16.2062V17.1875H16.4125V16.4938Z"
          fill="white"
        />
        <path
          d="M15.375 16.9813V17.1938H16.3187V16.9813H15.375ZM15.3125 16.4375V16.65H15.9125V16.4375H15.3125Z"
          fill="white"
        />
        <path
          d="M12.2812 15.9375H9.21875V16.1438H12.2812V15.9375ZM11.825 16.9875H11.6125V17.1938H11.825V16.9875ZM9.20625 16.9875V17.1938H9.81875V16.9813L9.20625 16.9875ZM8.875 15.9375H8.66875V17.1875H8.875V15.9375Z"
          fill="white"
        />
        <path
          d="M7.65625 16.9813V17.1938H8.81875V16.9813H7.65625ZM9.81875 16.4875H9.60625V17.1938L9.81875 17.1938V16.4875Z"
          fill="white"
        />
        <path
          d="M7.83125 15.9375H7.61875V17.1875H7.83125V15.9375ZM8.35625 15.9375H8.14375V17.1875H8.35625V15.9375ZM11.1562 16.4375V16.65H12.2812V16.4375H11.1562ZM8.7 16.4375V16.65H9.825V16.4375H8.7Z"
          fill="white"
        />
        <path
          d="M9.81875 16.4938H9.60625V17.1875H9.81875V16.4938Z"
          fill="white"
        />
        <path
          d="M9.81875 16.4938H9.60625V17.1875H9.81875V16.4938Z"
          fill="white"
        />
        <path
          d="M9.81875 16.4938H9.60625V17.1875H9.81875V16.4938ZM12.275 16.4938H12.0687V17.1875H12.275V16.4938ZM10.475 16.4938H10.2625V17.1875H10.475V16.4938ZM11.3687 16.4938H11.1562V17.1875H11.375L11.3687 16.4938Z"
          fill="white"
        />
        <path
          d="M10.325 16.9813V17.1938H11.275V16.9813H10.325ZM10.2625 16.4375V16.65H10.875V16.4375H10.2625Z"
          fill="white"
        />
        <path
          d="M38 -6H-18V4.5125H38V-6Z"
          fill="#239F40"
        />
        <path
          d="M7.20625 15.9375H4.14375V16.1438H7.20625V15.9375ZM6.75 16.9875H6.5375V17.1938H6.75V16.9875ZM4.13125 16.9875V17.1938H4.75V16.9813L4.13125 16.9875ZM3.8 15.9375H3.59375V17.1875H3.8V15.9375Z"
          fill="white"
        />
        <path
          d="M2.58125 16.9813V17.1938H3.74375V16.9813H2.58125ZM4.74375 16.4875H4.53125V17.1938L4.75 17.1938L4.74375 16.4875Z"
          fill="white"
        />
        <path
          d="M2.75 15.9375H2.54375V17.1875H2.75V15.9375ZM3.28125 15.9375H3.06875V17.1875H3.28125V15.9375ZM6.08125 16.4375V16.65H7.20625V16.4375H6.08125ZM3.625 16.4375V16.65H4.75V16.4375H3.625Z"
          fill="white"
        />
        <path
          d="M4.75 16.4938H4.53125V17.1875H4.75V16.4938Z"
          fill="white"
        />
        <path
          d="M4.75 16.4938H4.53125V17.1875H4.75V16.4938Z"
          fill="white"
        />
        <path
          d="M4.75 16.4938H4.53125V17.1875H4.75V16.4938ZM7.2 16.4938H6.9875V17.1875H7.2V16.4938ZM5.4 16.4938H5.1875V17.1875H5.4V16.4938ZM6.29375 16.4938H6.08125V17.1875H6.29375V16.4938Z"
          fill="white"
        />
        <path
          d="M5.25 16.9813V17.1938H6.2V16.9813H5.25ZM5.1875 16.4375V16.65H5.7875V16.4375H5.1875Z"
          fill="white"
        />
        <path
          d="M2.1625 15.9375H-0.900002V16.1438H2.1625V15.9375ZM1.70625 16.9875H1.49375V17.1938H1.70625V16.9875ZM-0.918752 16.9875V17.1938H-0.300002V16.9813L-0.918752 16.9875ZM-1.24375 15.9375H-1.45625V17.1875H-1.24375V15.9375Z"
          fill="white"
        />
        <path
          d="M-2.4625 16.9813V17.1938H-1.3V16.9813H-2.4625ZM-0.300002 16.4875H-0.512502V17.1938L-0.300002 17.1938V16.4875Z"
          fill="white"
        />
        <path
          d="M-2.29375 15.9375H-2.5V17.1875H-2.29375V15.9375ZM-1.7625 15.9375H-1.975V17.1875H-1.7625V15.9375ZM1.0375 16.4375V16.65H2.15625V16.4375H1.0375ZM-1.41875 16.4375V16.65H-0.300002V16.4375H-1.41875Z"
          fill="white"
        />
        <path
          d="M-0.300002 16.4938H-0.512502V17.1875H-0.300002V16.4938Z"
          fill="white"
        />
        <path
          d="M-0.300002 16.4938H-0.512502V17.1875H-0.300002V16.4938Z"
          fill="white"
        />
        <path
          d="M-0.300002 16.4938H-0.512502V17.1875H-0.300002V16.4938ZM2.15625 16.4938H1.94375V17.1875H2.15625V16.4938ZM0.356248 16.4938H0.143748V17.1875H0.356248V16.4938ZM1.25 16.4938H1.0375V17.1875H1.24375L1.25 16.4938Z"
          fill="white"
        />
        <path
          d="M0.206248 16.9813V17.1938H1.15V16.9813H0.206248ZM0.143748 16.4375V16.65H0.749998V16.4375H0.143748Z"
          fill="white"
        />
        <path
          d="M-2.8875 15.9375H-5.95V16.1438H-2.8875V15.9375ZM-3.34375 16.9875H-3.55625V17.1938H-3.34375V16.9875ZM-5.9625 16.9875V17.1938H-5.35V16.9813L-5.9625 16.9875ZM-6.2875 15.9375H-6.5V17.1875H-6.2875V15.9375Z"
          fill="white"
        />
        <path
          d="M-7.5125 16.9813V17.1938H-6.35V16.9813H-7.5125ZM-5.34375 16.4875H-5.55625V17.1938H-5.34375V16.4875Z"
          fill="white"
        />
        <path
          d="M-7.3375 15.9375H-7.55V17.1875H-7.3375V15.9375ZM-6.8125 15.9375H-7.01875V17.1875H-6.8125V15.9375ZM-4.0125 16.4375V16.65H-2.8875V16.4375H-4.0125ZM-6.46875 16.4375V16.65H-5.34375V16.4375H-6.46875Z"
          fill="white"
        />
        <path
          d="M-5.35 16.4938H-5.55625V17.1875H-5.35V16.4938Z"
          fill="white"
        />
        <path
          d="M-5.35 16.4938H-5.55625V17.1875H-5.35V16.4938Z"
          fill="white"
        />
        <path
          d="M-5.35 16.4938H-5.55625V17.1875H-5.35V16.4938ZM-2.8875 16.4938H-3.1V17.1875H-2.8875V16.4938ZM-4.69375 16.4938H-4.9V17.1875H-4.69375V16.4938ZM-3.8 16.4938H-4.0125V17.1875H-3.8V16.4938Z"
          fill="white"
        />
        <path
          d="M-4.8375 16.9813V17.1938H-3.89375V16.9813H-4.8375ZM-4.9 16.4375V16.65H-4.3V16.4375H-4.9Z"
          fill="white"
        />
        <path
          d="M-7.9625 15.9375H-11.025V16.1438H-7.9625V15.9375ZM-8.41875 16.9875H-8.63125V17.1938H-8.41875V16.9875ZM-11.0375 16.9875V17.1938H-10.425V16.9813L-11.0375 16.9875ZM-11.3625 15.9375H-11.575V17.1875H-11.3625V15.9375Z"
          fill="white"
        />
        <path
          d="M-12.5875 16.9813V17.1938H-11.425V16.9813H-12.5875ZM-10.425 16.4875H-10.6312V17.1938L-10.425 17.1938L-10.425 16.4875Z"
          fill="white"
        />
        <path
          d="M-12.4125 15.9375H-12.625V17.1875H-12.4125V15.9375ZM-11.8875 15.9375H-12.0938V17.1875H-11.8875V15.9375ZM-9.0875 16.4375V16.65H-7.9625V16.4375H-9.0875ZM-11.5438 16.4375V16.65H-10.4188V16.4375H-11.5438Z"
          fill="white"
        />
        <path
          d="M-10.425 16.4938H-10.6312V17.1875H-10.425V16.4938Z"
          fill="white"
        />
        <path
          d="M-10.425 16.4938H-10.6312V17.1875H-10.425V16.4938Z"
          fill="white"
        />
        <path
          d="M-10.425 16.4938H-10.6312V17.1875H-10.425V16.4938ZM-7.96875 16.4938H-8.175V17.1875H-7.96875V16.4938ZM-9.76875 16.4938H-9.98125V17.1875H-9.76875V16.4938ZM-8.875 16.4938H-9.0875V17.1875H-8.875V16.4938Z"
          fill="white"
        />
        <path
          d="M-9.9125 16.9813V17.1938H-8.96875V16.9813H-9.9125ZM-9.975 16.4375V16.65H-9.375V16.4375H-9.975Z"
          fill="white"
        />
        <path
          d="M37.4875 15.9375H34.425V16.1438H37.4875V15.9375ZM37.0312 16.9875H36.8188V17.1938H37.0312V16.9875ZM34.4062 16.9875V17.1938H35.025V16.9813L34.4062 16.9875ZM34.0812 15.9375H33.8687V17.1875H34.0812V15.9375Z"
          fill="white"
        />
        <path
          d="M32.8625 16.9813V17.1938H34.025V16.9813H32.8625ZM35.025 16.4875H34.8125V17.1938L35.025 17.1938L35.025 16.4875Z"
          fill="white"
        />
        <path
          d="M33.0312 15.9375H32.825V17.1875H33.0312V15.9375ZM33.5625 15.9375H33.35V17.1875H33.5625V15.9375ZM36.3625 16.4375V16.65H37.4812V16.4375H36.3625ZM33.9063 16.4375V16.65H35.025V16.4375H33.9063Z"
          fill="white"
        />
        <path
          d="M35.025 16.4938H34.8125V17.1875H35.025V16.4938Z"
          fill="white"
        />
        <path
          d="M35.025 16.4938H34.8125V17.1875H35.025V16.4938Z"
          fill="white"
        />
        <path
          d="M35.025 16.4938H34.8125V17.1875H35.025V16.4938ZM37.4812 16.4938H37.2688V17.1875H37.4812V16.4938ZM35.6812 16.4938H35.4688V17.1875H35.6812V16.4938ZM36.575 16.4938H36.3625V17.1875H36.575V16.4938Z"
          fill="white"
        />
        <path
          d="M35.5313 16.9813V17.1938H36.4812V16.9813H35.5313ZM35.4688 16.4375V16.65H36.0688V16.4375H35.4688Z"
          fill="white"
        />
        <path
          d="M27.35 2.9625H24.2875V3.175H27.35V2.9625ZM26.8937 4.025H26.6812V4.225H26.8937V4.025ZM24.275 4.0125V4.225H24.8875V4.0125H24.275ZM23.95 2.9625H23.7375V4.225H23.95V2.9625Z"
          fill="white"
        />
        <path
          d="M22.725 4.0125V4.225H23.8875V4.0125H22.725ZM24.8875 3.51875H24.6875V4.225H24.8937L24.8875 3.51875Z"
          fill="white"
        />
        <path
          d="M22.9 2.9625H22.6875V4.225H22.9V2.9625ZM23.425 2.9625H23.2187V4.225H23.425V2.9625ZM26.225 3.4625V3.675H27.35V3.46875L26.225 3.4625ZM23.7687 3.4625V3.675H24.8937V3.46875L23.7687 3.4625Z"
          fill="white"
        />
        <path
          d="M24.8875 3.51875H24.6875V4.225H24.8937L24.8875 3.51875Z"
          fill="white"
        />
        <path
          d="M24.8875 3.51875H24.6875V4.225H24.8937L24.8875 3.51875Z"
          fill="white"
        />
        <path
          d="M24.8875 3.51875H24.6875V4.225H24.8937L24.8875 3.51875ZM27.3437 3.51875H27.1375V4.225H27.3437V3.51875ZM25.5437 3.51875H25.3312V4.225H25.5437V3.51875ZM26.4375 3.51875H26.225V4.225H26.4375V3.51875Z"
          fill="white"
        />
        <path
          d="M25.4 4.0125V4.225H26.3437V4.0125H25.4ZM25.3375 3.46875V3.675H25.9375V3.46875H25.3375Z"
          fill="white"
        />
        <path
          d="M32.3875 2.9625H29.325V3.175H32.3875V2.9625ZM31.9313 4.025H31.7187V4.225H31.9375L31.9313 4.025ZM29.3125 4.0125V4.225H29.925V4.0125H29.3125ZM28.9875 2.9625H28.775V4.225H28.9875V2.9625Z"
          fill="white"
        />
        <path
          d="M27.7625 4.0125V4.225H28.925V4.0125H27.7625ZM29.925 3.51875H29.7187V4.225L29.925 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M27.9375 2.9625H27.725V4.225H27.9375V2.9625ZM28.4625 2.9625H28.2562V4.225H28.4625V2.9625ZM31.2625 3.4625V3.675H32.3875V3.46875L31.2625 3.4625ZM28.8062 3.4625V3.675H29.9313V3.46875L28.8062 3.4625Z"
          fill="white"
        />
        <path
          d="M29.925 3.51875H29.7187V4.225L29.925 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M29.925 3.51875H29.7187V4.225L29.925 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M29.925 3.51875H29.7187V4.225L29.925 4.225V3.51875ZM32.3812 3.51875H32.175V4.225H32.3812V3.51875ZM30.5812 3.51875H30.375V4.225H30.5812V3.51875ZM31.475 3.51875H31.2625V4.225H31.475V3.51875Z"
          fill="white"
        />
        <path
          d="M30.4375 4.0125V4.225H31.375V4.0125H30.4375ZM30.375 3.46875V3.675H30.975V3.46875H30.375Z"
          fill="white"
        />
        <path
          d="M22.3562 2.9625H19.2937V3.175H22.3562V2.9625ZM21.9 4.025H21.6875V4.225H21.9V4.025ZM19.2812 4.0125V4.225H19.8937V4.0125H19.2812ZM18.95 2.9625H18.7375V4.225H18.95V2.9625Z"
          fill="white"
        />
        <path
          d="M17.7312 4.0125V4.225H18.8937V4.0125H17.7312ZM19.8937 3.51875H19.6812V4.225L19.8937 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M17.9062 2.9625H17.6937V4.225H17.9062V2.9625ZM18.4312 2.9625H18.2187V4.225H18.4375L18.4312 2.9625ZM21.2312 3.4625V3.675H22.3562V3.46875L21.2312 3.4625ZM18.775 3.4625V3.675H19.9V3.46875L18.775 3.4625Z"
          fill="white"
        />
        <path
          d="M19.8937 3.51875H19.6812V4.225L19.8937 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M19.8937 3.51875H19.6812V4.225L19.8937 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M19.8937 3.51875H19.6812V4.225L19.8937 4.225V3.51875ZM22.35 3.51875H22.1375V4.225H22.35V3.51875ZM20.55 3.51875H20.3375V4.225H20.55V3.51875ZM21.4437 3.51875H21.2312V4.225H21.4437V3.51875Z"
          fill="white"
        />
        <path
          d="M20.4 4.0125V4.225H21.35V4.0125H20.4ZM20.3375 3.46875V3.675H20.9375V3.46875H20.3375Z"
          fill="white"
        />
        <path
          d="M-12.9188 2.9625H-15.9813V3.175H-12.9188V2.9625ZM-13.375 4.025H-13.5875V4.225H-13.375V4.025ZM-15.9938 4.0125V4.225H-15.375V4.0125H-15.9938ZM-16.325 2.9625H-16.5313V4.225H-16.3187L-16.325 2.9625Z"
          fill="white"
        />
        <path
          d="M-17.5438 4.0125V4.225H-16.375V4.0125H-17.5438ZM-15.3813 3.51875H-15.5938V4.225L-15.375 4.225L-15.3813 3.51875Z"
          fill="white"
        />
        <path
          d="M-17.375 2.9625H-17.5813V4.225H-17.3688L-17.375 2.9625ZM-16.8438 2.9625H-17.0563V4.225H-16.8438V2.9625ZM-14.0438 3.4625V3.675H-12.9188V3.46875L-14.0438 3.4625ZM-16.5 3.4625V3.675H-15.375V3.46875L-16.5 3.4625Z"
          fill="white"
        />
        <path
          d="M-15.375 3.51875H-15.5938V4.225L-15.375 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-15.375 3.51875H-15.5938V4.225L-15.375 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-15.375 3.51875H-15.5938V4.225L-15.375 4.225V3.51875ZM-12.925 3.51875H-13.1375V4.225H-12.925V3.51875ZM-14.725 3.51875H-14.9375V4.225H-14.725V3.51875ZM-13.8313 3.51875H-14.0438V4.225H-13.8313V3.51875Z"
          fill="white"
        />
        <path
          d="M-14.875 4.0125V4.225H-13.925V4.0125H-14.875ZM-14.9375 3.46875V3.675H-14.3375V3.46875H-14.9375Z"
          fill="white"
        />
        <path
          d="M17.3312 2.9625H14.2625V3.175H17.325L17.3312 2.9625ZM16.8687 4.025H16.6625V4.225H16.8687V4.025ZM14.2562 4.0125V4.225H14.8687V4.0125H14.2562ZM13.925 2.9625H13.7125V4.225H13.925V2.9625Z"
          fill="white"
        />
        <path
          d="M12.7 4.0125V4.225H13.8625V4.0125H12.7ZM14.8687 3.51875H14.6562V4.225L14.8687 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M12.875 2.9625H12.6625V4.225H12.875V2.9625ZM13.4062 2.9625H13.1937V4.225H13.4062V2.9625ZM16.2062 3.4625V3.675H17.325V3.46875L16.2062 3.4625ZM13.75 3.4625V3.675H14.8687V3.46875L13.75 3.4625Z"
          fill="white"
        />
        <path
          d="M14.8687 3.51875H14.6562V4.225L14.8687 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M14.8687 3.51875H14.6562V4.225L14.8687 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M14.8687 3.51875H14.6562V4.225L14.8687 4.225V3.51875ZM17.325 3.51875H17.1125V4.225H17.325V3.51875ZM15.525 3.51875H15.3125V4.225H15.525V3.51875ZM16.4125 3.51875H16.2062V4.225H16.4125V3.51875Z"
          fill="white"
        />
        <path
          d="M15.375 4.0125V4.225H16.3187V4.0125H15.375ZM15.3125 3.46875V3.675H15.9125V3.46875H15.3125Z"
          fill="white"
        />
        <path
          d="M12.2812 2.9625H9.21875V3.175H12.2812V2.9625ZM11.825 4.025H11.6125V4.225H11.825V4.025ZM9.20625 4.0125V4.225H9.81875V4.0125H9.20625ZM8.875 2.9625H8.66875V4.225H8.875V2.9625Z"
          fill="white"
        />
        <path
          d="M7.65625 4.0125V4.225H8.81875V4.0125H7.65625ZM9.81875 3.51875H9.60625V4.225L9.81875 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M7.83125 2.9625H7.61875V4.225H7.83125V2.9625ZM8.35625 2.9625H8.14375V4.225H8.35625V2.9625ZM11.1562 3.4625V3.675H12.2812V3.46875L11.1562 3.4625ZM8.7 3.4625V3.675H9.825V3.46875L8.7 3.4625Z"
          fill="white"
        />
        <path
          d="M9.81875 3.51875H9.60625V4.225L9.81875 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M9.81875 3.51875H9.60625V4.225L9.81875 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M9.81875 3.51875H9.60625V4.225L9.81875 4.225V3.51875ZM12.275 3.51875H12.0687V4.225H12.275V3.51875ZM10.475 3.51875H10.2625V4.225H10.475V3.51875ZM11.3687 3.51875H11.1562V4.225H11.375L11.3687 3.51875Z"
          fill="white"
        />
        <path
          d="M10.325 4.0125V4.225H11.275V4.0125H10.325ZM10.2625 3.46875V3.675H10.875V3.46875H10.2625Z"
          fill="white"
        />
        <path
          d="M7.20625 2.9625H4.14375V3.175H7.20625V2.9625ZM6.75 4.025H6.5375V4.225H6.75V4.025ZM4.13125 4.0125V4.225H4.75V4.0125H4.13125ZM3.8 2.9625H3.59375V4.225H3.8V2.9625Z"
          fill="white"
        />
        <path
          d="M2.58125 4.0125V4.225H3.74375V4.0125H2.58125ZM4.74375 3.51875H4.53125V4.225L4.75 4.225L4.74375 3.51875Z"
          fill="white"
        />
        <path
          d="M2.75 2.9625H2.54375V4.225H2.75V2.9625ZM3.28125 2.9625H3.06875V4.225H3.28125V2.9625ZM6.08125 3.4625V3.675H7.20625V3.46875L6.08125 3.4625ZM3.625 3.4625V3.675H4.75V3.46875L3.625 3.4625Z"
          fill="white"
        />
        <path
          d="M4.75 3.51875H4.53125V4.225L4.75 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M4.75 3.51875H4.53125V4.225L4.75 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M4.75 3.51875H4.53125V4.225L4.75 4.225V3.51875ZM7.2 3.51875H6.9875V4.225H7.2V3.51875ZM5.4 3.51875H5.1875V4.225H5.4V3.51875ZM6.29375 3.51875H6.08125V4.225H6.29375V3.51875Z"
          fill="white"
        />
        <path
          d="M5.25 4.0125V4.225H6.2V4.0125H5.25ZM5.1875 3.46875V3.675H5.7875V3.46875H5.1875Z"
          fill="white"
        />
        <path
          d="M2.1625 2.9625H-0.900002V3.175H2.1625V2.9625ZM1.70625 4.025H1.49375V4.225H1.70625V4.025ZM-0.918752 4.0125V4.225H-0.300002V4.0125H-0.918752ZM-1.24375 2.9625H-1.45625V4.225H-1.24375V2.9625Z"
          fill="white"
        />
        <path
          d="M-2.4625 4.0125V4.225H-1.3V4.0125H-2.4625ZM-0.300002 3.51875H-0.512502V4.225L-0.300002 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-2.29375 2.9625H-2.5V4.225H-2.29375V2.9625ZM-1.7625 2.9625H-1.975V4.225H-1.7625V2.9625ZM1.0375 3.4625V3.675H2.15625V3.46875L1.0375 3.4625ZM-1.41875 3.4625V3.675H-0.300002V3.46875L-1.41875 3.4625Z"
          fill="white"
        />
        <path
          d="M-0.300002 3.51875H-0.512502V4.225L-0.300002 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-0.300002 3.51875H-0.512502V4.225L-0.300002 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-0.300002 3.51875H-0.512502V4.225L-0.300002 4.225V3.51875ZM2.15625 3.51875H1.94375V4.225H2.15625V3.51875ZM0.356248 3.51875H0.143748V4.225H0.356248V3.51875ZM1.25 3.51875H1.0375V4.225H1.24375L1.25 3.51875Z"
          fill="white"
        />
        <path
          d="M0.206248 4.0125V4.225H1.15V4.0125H0.206248ZM0.143748 3.46875V3.675H0.749998V3.46875H0.143748Z"
          fill="white"
        />
        <path
          d="M-2.8875 2.9625H-5.95V3.175H-2.8875V2.9625ZM-3.34375 4.025H-3.55625V4.225H-3.34375V4.025ZM-5.9625 4.0125V4.225H-5.35V4.0125H-5.9625ZM-6.2875 2.9625H-6.5V4.225H-6.2875V2.9625Z"
          fill="white"
        />
        <path
          d="M-7.5125 4.0125V4.225H-6.35V4.0125H-7.5125ZM-5.34375 3.51875H-5.55625V4.225H-5.34375V3.51875Z"
          fill="white"
        />
        <path
          d="M-7.3375 2.9625H-7.55V4.225H-7.3375V2.9625ZM-6.8125 2.9625H-7.01875V4.225H-6.8125V2.9625ZM-4.0125 3.4625V3.675H-2.8875V3.46875L-4.0125 3.4625ZM-6.46875 3.4625V3.675H-5.34375V3.46875L-6.46875 3.4625Z"
          fill="white"
        />
        <path
          d="M-5.35 3.51875H-5.55625V4.225L-5.35 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-5.35 3.51875H-5.55625V4.225L-5.35 4.225V3.51875Z"
          fill="white"
        />
        <path
          d="M-5.35 3.51875H-5.55625V4.225L-5.35 4.225V3.51875ZM-2.8875 3.51875H-3.1V4.225H-2.8875V3.51875ZM-4.69375 3.51875H-4.9V4.225H-4.69375V3.51875ZM-3.8 3.51875H-4.0125V4.225H-3.8V3.51875Z"
          fill="white"
        />
        <path
          d="M-4.8375 4.0125V4.225H-3.89375V4.0125H-4.8375ZM-4.9 3.46875V3.675H-4.3V3.46875H-4.9Z"
          fill="white"
        />
        <path
          d="M-7.9625 2.9625H-11.025V3.175H-7.9625V2.9625ZM-8.41875 4.025H-8.63125V4.225H-8.41875V4.025ZM-11.0375 4.0125V4.225H-10.425V4.0125H-11.0375ZM-11.3625 2.9625H-11.575V4.225H-11.3625V2.9625Z"
          fill="white"
        />
        <path
          d="M-12.5875 4.0125V4.225H-11.425V4.0125H-12.5875ZM-10.425 3.51875H-10.6312V4.225L-10.425 4.225L-10.425 3.51875Z"
          fill="white"
        />
        <path
          d="M-12.4125 2.9625H-12.625V4.225H-12.4125V2.9625ZM-11.8875 2.9625H-12.0938V4.225H-11.8875V2.9625ZM-9.0875 3.4625V3.675H-7.9625V3.46875L-9.0875 3.4625ZM-11.5438 3.4625V3.675H-10.4188V3.46875L-11.5438 3.4625Z"
          fill="white"
        />
        <path
          d="M-10.425 3.51875H-10.6312V4.225L-10.425 4.225L-10.425 3.51875Z"
          fill="white"
        />
        <path
          d="M-10.425 3.51875H-10.6312V4.225L-10.425 4.225L-10.425 3.51875Z"
          fill="white"
        />
        <path
          d="M-10.425 3.51875H-10.6312V4.225L-10.425 4.225L-10.425 3.51875ZM-7.96875 3.51875H-8.175V4.225H-7.96875V3.51875ZM-9.76875 3.51875H-9.98125V4.225H-9.76875V3.51875ZM-8.875 3.51875H-9.0875V4.225H-8.875V3.51875Z"
          fill="white"
        />
        <path
          d="M-9.9125 4.0125V4.225H-8.96875V4.0125H-9.9125ZM-9.975 3.46875V3.675H-9.375V3.46875H-9.975Z"
          fill="white"
        />
        <path
          d="M37.4875 2.9625H34.425V3.175H37.4875V2.9625ZM37.0312 4.025H36.8188V4.225H37.0312V4.025ZM34.4062 4.0125V4.225H35.025V4.0125H34.4062ZM34.0812 2.9625H33.8687V4.225H34.0812V2.9625Z"
          fill="white"
        />
        <path
          d="M32.8625 4.0125V4.225H34.025V4.0125H32.8625ZM35.025 3.51875H34.8125V4.225L35.025 4.225L35.025 3.51875Z"
          fill="white"
        />
        <path
          d="M33.0312 2.9625H32.825V4.225H33.0312V2.9625ZM33.5625 2.9625H33.35V4.225H33.5625V2.9625ZM36.3625 3.4625V3.675H37.4812V3.46875L36.3625 3.4625ZM33.9063 3.4625V3.675H35.025V3.46875L33.9063 3.4625Z"
          fill="white"
        />
        <path
          d="M35.025 3.51875H34.8125V4.225L35.025 4.225L35.025 3.51875Z"
          fill="white"
        />
        <path
          d="M35.025 3.51875H34.8125V4.225L35.025 4.225L35.025 3.51875Z"
          fill="white"
        />
        <path
          d="M35.025 3.51875H34.8125V4.225L35.025 4.225L35.025 3.51875ZM37.4812 3.51875H37.2688V4.225H37.4812V3.51875ZM35.6812 3.51875H35.4688V4.225H35.6812V3.51875ZM36.575 3.51875H36.3625V4.225H36.575V3.51875Z"
          fill="white"
        />
        <path
          d="M35.5313 4.0125V4.225H36.4812V4.0125H35.5313ZM35.4688 3.46875V3.675H36.0688V3.46875H35.4688Z"
          fill="white"
        />
        <path
          d="M30.3 15.2188H29.925V15.875H30.3V15.2188ZM20.2687 15.2188H19.8937V15.875H20.2687V15.2188ZM38 15.2188H37.625V15.875H38V15.2188ZM32.9062 15.2188H32.5312V15.875H32.9062V15.2188ZM27.85 15.2188H27.475V15.875H27.85V15.2188ZM25.35 15.2188H24.975V15.875H25.35V15.2188ZM22.7937 15.2188H22.4187V15.875H22.7937V15.2188ZM17.7687 15.2188H17.3937V15.875H17.7687V15.2188ZM5.08125 15.2188H4.7V15.875H5.075L5.08125 15.2188ZM15.2125 15.2188H14.8375V15.875H15.2125V15.2188ZM12.7125 15.2188H12.3375V15.875H12.7125V15.2188ZM10.1812 15.2188H9.80625V15.875H10.1812V15.2188ZM7.65625 15.2188H7.28125V15.875H7.65625V15.2188ZM-12.5438 15.2188H-12.9188V15.875H-12.5438V15.2188ZM2.625 15.2188H2.25V15.875H2.625V15.2188ZM0.074998 15.2188H-0.300002V15.875H0.074998V15.2188ZM-2.50625 15.2188H-2.88125V15.875H-2.50625V15.2188ZM-4.93125 15.2188H-5.30625V15.875H-4.93125V15.2188ZM-7.5125 15.2188H-7.8875V15.875H-7.5125V15.2188ZM-10.0375 15.2188H-10.4125V15.875H-10.0375V15.2188ZM-17.5188 15.2188H-17.8938V15.875H-17.5188V15.2188ZM-15.0938 15.2188H-15.4688V15.875H-15.0938V15.2188ZM35.4625 15.2188H35.0875V15.875H35.4625V15.2188Z"
          fill="#D90000"
        />
        <path
          d="M30.3 4.1625H29.925V4.81875H30.3V4.1625ZM20.2687 4.1625H19.8937V4.81875H20.2687V4.1625ZM38 4.1625H37.625V4.81875H38V4.1625ZM32.9062 4.1625H32.5312V4.81875H32.9062V4.1625ZM27.85 4.1625H27.475V4.81875H27.85V4.1625ZM25.35 4.1625H24.975V4.81875H25.35V4.1625ZM22.7937 4.1625H22.4187V4.81875H22.7937V4.1625ZM17.7687 4.1625H17.3937V4.81875H17.7687V4.1625ZM5.08125 4.1625H4.7V4.81875H5.075L5.08125 4.1625ZM15.2125 4.1625H14.8375V4.81875H15.2125V4.1625ZM12.7125 4.1625H12.3375V4.81875H12.7125V4.1625ZM10.1812 4.1625H9.80625V4.81875H10.1812V4.1625ZM7.65625 4.1625H7.28125V4.81875H7.65625V4.1625ZM-12.5438 4.1625H-12.9188V4.81875H-12.5438V4.1625ZM2.625 4.1625H2.25V4.81875H2.625V4.1625ZM0.074998 4.1625H-0.300002V4.81875H0.074998V4.1625ZM-2.50625 4.1625H-2.88125V4.81875H-2.50625V4.1625ZM-4.93125 4.1625H-5.30625V4.81875H-4.93125V4.1625ZM-7.5125 4.1625H-7.8875V4.81875H-7.5125V4.1625ZM-10.0375 4.1625H-10.4125V4.81875H-10.0375V4.1625ZM-17.5188 4.1625H-17.8938V4.81875H-17.5188V4.1625ZM-15.0938 4.1625H-15.4688V4.81875H-15.0938V4.1625ZM35.4625 4.1625H35.0875V4.81875H35.4625V4.1625Z"
          fill="#239E3F"
        />
        <path
          d="M8.5125 6.34375C7.9875 6.99375 6.35625 10.5688 9.49375 12.9188C10.975 14.0313 10.0562 14.0812 10.0125 14.2687C7.6375 13.0125 6.86875 11.3 6.8875 9.76875C6.9 8.24375 7.7125 6.89375 8.5125 6.34375Z"
          fill="#DA0000"
        />
        <path
          d="M8.2 6.175C7.62012 6.52785 7.12589 7.00515 6.75306 7.57239C6.38023 8.13963 6.1381 8.78264 6.0442 9.45491C5.9503 10.1272 6.00696 10.8119 6.21009 11.4596C6.41322 12.1073 6.75775 12.7018 7.21875 13.2C5.51875 12.825 3.34375 7.8 8.2 6.175ZM11.8 6.175C12.3794 6.52838 12.8731 7.00609 13.2453 7.57359C13.6176 8.14108 13.8591 8.7842 13.9524 9.45644C14.0457 10.1287 13.9884 10.8132 13.7848 11.4607C13.5812 12.1081 13.2363 12.7022 12.775 13.2C14.4812 12.825 16.65 7.8 11.8 6.175Z"
          fill="#DA0000"
        />
        <path
          d="M11.4875 6.34375C12.0125 6.99375 13.6438 10.5688 10.5063 12.9188C9.03125 14.0313 9.94375 14.0812 9.9875 14.2687C12.3625 13.0125 13.1313 11.3 13.1125 9.76875C13.1 8.24375 12.2875 6.89375 11.4875 6.34375Z"
          fill="#DA0000"
        />
        <path
          d="M6.9875 13.9438C7.91875 13.9563 9.0875 13.8188 9.95625 13.3625C9.8125 13.6438 9.69375 13.8188 9.55 14.0938C8.725 14.175 7.58125 14.2688 6.9875 13.9438ZM12.925 13.9438C11.9937 13.9563 10.825 13.8188 9.95625 13.3625C10.1 13.6438 10.2187 13.8188 10.3625 14.0938C11.1875 14.175 12.3312 14.2688 12.925 13.9438ZM11.2187 5.275C11.0312 5.775 10.5375 5.85 10.0125 5.55625C9.625 5.78125 9.03125 5.8 8.825 5.3C8.66875 6.5375 9.96875 6.2375 10.0125 6C10.5 6.46875 11.4 6.2 11.2187 5.275Z"
          fill="#DA0000"
        />
        <path
          d="M9.975 14.725L9.4875 14.1625L9.41875 6.65625L10 6.14375L10.5812 6.63125L10.4625 14.1938L9.975 14.725Z"
          fill="#DA0000"
        />
      </g>
    </svg>
  );
};
